import React from "react";
import ReleaseDateView from "./view";
import { noop } from '@client/shared/constants';

const ReleaseDatePanel = ({
  immediateRelease = false,
  releaseDay = '',
  releaseMonth = null,
  releaseYear = '',
  releaseTime = '',
  releaseMeridiem = 'AM',
  timeZone = "",
  handleChange = noop
}) => {
  return (
    <ReleaseDateView
      immediateRelease={immediateRelease}
      releaseDay={releaseDay}
      releaseMonth={releaseMonth}
      releaseYear={releaseYear}
      releaseTime={releaseTime}
      releaseMeridiem={releaseMeridiem}
      timeZone={timeZone}
      handleChange={handleChange}
    />
  )
};

export default ReleaseDatePanel;